import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function LegalPage({ title, label, lastUpdated, intro, sections }) {
  const [active, setActive] = useState(null);

  return (
    <div className="page-top">
      {/* Hero */}
      <div style={S.hero}>
        <div style={S.heroBg}>{title.split(' ')[0]}</div>
        <div style={S.heroContent}>
          <p className="sec-label" style={{ color: 'var(--gold)', marginBottom: '10px' }}>{label}</p>
          <h1 style={S.heroTitle}>{title}</h1>
          <p style={S.heroMeta}>Last updated: {lastUpdated}</p>
        </div>
      </div>

      <div style={S.layout}>
        {/* Main Content */}
        <main style={S.main}>
          <div style={S.introBox}>
            <p style={S.introText}>{intro}</p>
          </div>

          {sections.map((sec, i) => (
            <div key={i} style={S.section}>
              <h2 style={S.secTitle}>{i + 1}. {sec.title}</h2>
              <div style={S.secBody}>
                {sec.body.split('\n').map((line, j) => (
                  line.trim() === '' ? null :
                  line.startsWith('•') ? (
                    <p key={j} style={S.bullet}>{line}</p>
                  ) : (
                    <p key={j} style={S.para}>{line}</p>
                  )
                ))}
              </div>
            </div>
          ))}
        </main>

        {/* Sidebar TOC */}
        <aside style={S.sidebar}>
          <div style={S.tocCard}>
            <p style={S.tocTitle}>CONTENTS</p>
            {sections.map((sec, i) => (
              <a key={i} href={`#sec-${i}`} style={S.tocLink} onClick={(e) => { e.preventDefault(); setActive(i); }}>
                <span style={{ color: active === i ? 'var(--red)' : '#bbb', fontSize: '10px', fontWeight: 700, marginRight: '6px' }}>{String(i + 1).padStart(2, '0')}</span>
                <span style={{ color: active === i ? 'var(--black)' : '#555', fontWeight: active === i ? 700 : 400 }}>{sec.title}</span>
              </a>
            ))}
          </div>

          <div style={S.helpCard}>
            <p style={S.helpTitle}>QUESTIONS?</p>
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,.45)', lineHeight: 1.7, marginBottom: '14px' }}>
              If you need clarification on any of our policies, our team is here to help.
            </p>
            <Link to="/contact" style={S.helpCta}>Contact Us →</Link>
          </div>

          <div style={S.linksCard}>
            <p style={S.linksTitle}>RELATED POLICIES</p>
            {[
              { to: '/privacy-policy', label: 'Privacy Policy' },
              { to: '/terms-of-use', label: 'Terms of Use' },
              { to: '/disclaimer', label: 'Disclaimer' },
              { to: '/returns', label: 'Returns Policy' },
            ].map((l) => (
              <Link key={l.to} to={l.to} style={S.policyLink}>{l.label} →</Link>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}

const S = {
  hero:        { background: 'var(--black)', padding: '60px 56px 52px', position: 'relative', overflow: 'hidden', borderBottom: '4px solid var(--gold)' },
  heroBg:      { position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', fontFamily: 'var(--font-display)', fontSize: 'clamp(60px,14vw,180px)', letterSpacing: '-4px', color: 'rgba(255,255,255,.04)', lineHeight: 1, userSelect: 'none' },
  heroContent: { position: 'relative', zIndex: 1 },
  heroTitle:   { fontFamily: 'var(--font-display)', fontSize: 'clamp(28px,5vw,52px)', letterSpacing: '2px', color: '#fff', lineHeight: 1, marginBottom: '12px' },
  heroMeta:    { fontSize: '12px', color: 'rgba(255,255,255,.35)', fontWeight: 600, letterSpacing: '.5px' },
  layout:      { display: 'grid', gridTemplateColumns: '1fr 280px', gap: '36px', padding: '48px 56px 80px', maxWidth: '1200px', margin: '0 auto', alignItems: 'start' },
  main:        {},
  introBox:    { background: 'var(--offwhite)', border: '1px solid var(--border)', borderLeft: '4px solid var(--gold)', padding: '20px 22px', marginBottom: '32px' },
  introText:   { fontSize: '14px', color: '#555', lineHeight: 1.85, margin: 0 },
  section:     { marginBottom: '36px', paddingBottom: '32px', borderBottom: '1px solid var(--border)' },
  secTitle:    { fontFamily: 'var(--font-display)', fontSize: '17px', letterSpacing: '1.5px', marginBottom: '14px', color: 'var(--black)' },
  secBody:     {},
  para:        { fontSize: '13.5px', color: '#555', lineHeight: 1.85, marginBottom: '10px' },
  bullet:      { fontSize: '13.5px', color: '#555', lineHeight: 1.85, marginBottom: '6px', paddingLeft: '4px' },
  sidebar:     { position: 'sticky', top: '120px', display: 'flex', flexDirection: 'column', gap: '14px' },
  tocCard:     { background: '#fff', border: '1px solid var(--border)', padding: '18px' },
  tocTitle:    { fontFamily: 'var(--font-display)', fontSize: '11px', letterSpacing: '3px', color: '#aaa', marginBottom: '12px' },
  tocLink:     { display: 'flex', alignItems: 'flex-start', gap: '0', padding: '7px 0', borderBottom: '1px solid var(--border)', textDecoration: 'none', fontSize: '12px', transition: 'color .15s', cursor: 'pointer' },
  helpCard:    { background: 'var(--black)', padding: '18px', borderLeft: '3px solid var(--red)' },
  helpTitle:   { fontFamily: 'var(--font-display)', fontSize: '12px', letterSpacing: '2px', color: 'rgba(255,255,255,.5)', marginBottom: '8px' },
  helpCta:     { display: 'inline-block', background: 'var(--red)', color: '#fff', padding: '8px 16px', fontSize: '10px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', textDecoration: 'none' },
  linksCard:   { background: '#fff', border: '1px solid var(--border)', padding: '18px' },
  linksTitle:  { fontFamily: 'var(--font-display)', fontSize: '11px', letterSpacing: '3px', color: '#aaa', marginBottom: '10px' },
  policyLink:  { display: 'block', padding: '7px 0', borderBottom: '1px solid var(--border)', textDecoration: 'none', fontSize: '12px', color: '#555', fontWeight: 500, transition: 'color .15s' },
};
